import { render, staticRenderFns } from "./PlacePartFloatBtns.vue?vue&type=template&id=6e88bc6a&"
import script from "./PlacePartFloatBtns.vue?vue&type=script&lang=js&"
export * from "./PlacePartFloatBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports